import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import IconBase from "../IconBase";
var Youtube = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 24 : _width, _height = _param.height, height = _height === void 0 ? 24 : _height, _color = _param.color, color = _color === void 0 ? "white" : _color, props = _object_without_properties(_param, [
        "width",
        "height",
        "color"
    ]);
    return /*#__PURE__*/ _jsx(IconBase, _object_spread_props(_object_spread({
        $styles: {
            width: width,
            height: height
        },
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M22.9991 9.70998C23.0485 8.27864 22.7355 6.858 22.0891 5.57998C21.6505 5.05558 21.0418 4.70169 20.3691 4.57998C17.5866 4.32751 14.7926 4.22403 11.9991 4.26998C9.2157 4.22194 6.43176 4.32208 3.65905 4.56998C3.11087 4.6697 2.60357 4.92683 2.19905 5.30998C1.29905 6.13998 1.19905 7.55998 1.09905 8.75998C0.953962 10.9175 0.953962 13.0824 1.09905 15.24C1.12798 15.9154 1.22854 16.5858 1.39905 17.24C1.51963 17.745 1.76357 18.2123 2.10905 18.6C2.51632 19.0034 3.03543 19.2752 3.59905 19.38C5.75497 19.6461 7.92727 19.7564 10.0991 19.71C13.5991 19.76 16.669 19.71 20.299 19.43C20.8765 19.3316 21.4102 19.0595 21.8291 18.65C22.109 18.3699 22.3181 18.0271 22.4391 17.65C22.7967 16.5526 22.9723 15.4041 22.959 14.25C22.9991 13.69 22.9991 10.31 22.9991 9.70998ZM9.73905 14.85V8.65998L15.659 11.77C13.9991 12.69 11.809 13.73 9.73905 14.85Z",
            fill: color
        })
    }));
};
export default Youtube;
